import * as Action from '../action';
import * as Constant from '../../constant';

const initialState = {
  downloading: false,
  activeForm: 0,

  filters: {
    [Constant.TABLE_FIELD_CONTAINER_NUMBER]: '',
    [Constant.TABLE_FIELD_TRUCKER]: '',
    [Constant.TABLE_FIELD_CONSIGNEE]: '',
  },
  sortField: '',
  sortDirection: '',
  activePage: 1,
  pageSize: 5,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.DOWNLOADING_ASSIGN_CONTAINER:
      return { ...state, downloading: action.status };
    case Action.SET_ASSIGN_CONTAINER_ACTIVE_FORM:
      return { ...state, activeForm: action.value };
    case Action.SET_ASSIGN_CONTAINER_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.value,
        },
      };
    }
    case Action.SET_ASSIGN_CONTAINER_PAGING: {
      return { ...state, ...action.value };
    }
    case Action.SET_ASSIGN_CONTAINER_SORT: {
      return { ...state, sortField: action.sortField, sortDirection: action.sortDirection };
    }
    default: return state;
  }
};
